<template>
  <div class="ds-custom-drop-tree_item" @contextmenu="onContextmenu">
    <div class="item-nothover">
      <slot name="default" :data="data">
        <span class="item-field">{{ data.field || "无字段" }}</span>
        <el-select
          size="small"
          class="item-op"
          v-model="data.operator"
          :disabled="!notReadOnly"
        >
          <el-option label="等于" value="eq"></el-option>
          <el-option label="不等于" value="noteq"></el-option>
          <el-option label="大于" value="gt"></el-option>
          <el-option label="小于" value="lt"></el-option>
          <el-option label="大于等于" value="gteq"></el-option>
          <el-option label="小于等于" value="lteq"></el-option>
          <el-option label="模糊匹配" value="like"></el-option>
          <el-option label="开头匹配" value="slike"></el-option>
          <el-option label="结尾匹配" value="elike"></el-option>
          <el-option label="区间" value="between"></el-option>
          <el-option label="介于" value="gtlt"></el-option>
          <el-option label="空" value="is_null"></el-option>
          <el-option label="非空" value="is_not_null"></el-option>
          <el-option label="包含" value="in"></el-option>
          <el-option label="不包含" value="notin"></el-option>
          <el-option label="在列表" value="in_list"></el-option>
          <el-option label="不在列表" value="not_in_list"></el-option>
        </el-select>
        <div
          class="item-value"
          v-if="data.operator != 'is_null' && data.operator != 'is_not_null'"
        >
          <el-input
            v-model="data.value"
            size="small"
            :disabled="!notReadOnly"
          />
        </div>
        <template
          v-if="
            (data.operator != 'is_null' &&
              data.operator != 'is_not_null' &&
              data.operator == 'between') || data.operator == 'gtlt'"
        >
          <span class="item-text">至</span>
          <div class="item-value">
            <el-input
              v-model="data.value2"
              size="small"
              :disabled="!notReadOnly"
            />
          </div>
        </template>
        <i
          v-if="notReadOnly && data.operator!='is_null' && data.operator!='is_not_null'"
          class="iconfont icon-rukuqingkuang const"
          title="选择"
          @click="openChoose"
        ></i>
      </slot>
      <slot name="more" :data="owner">
      </slot>
      <div
        class="item-close"
        @click="remove()"
        v-if="notReadOnly && !data.isReadOnly && !data.items"
      >
        <DsfIcon name="icon_close" title="删除"></DsfIcon>
      </div>
    </div>
    <div class="item-hovering">
      <div
        class="pos-top"
        @mouseover="mouseOverHandler($event, 'before')"
      ></div>
      <div
        class="pos-bottom"
        @mouseover="mouseOverHandler($event, 'after')"
      ></div>
    </div>

    <slot name="bottom" :data="owner"></slot>

    <choose-dialog ref="chooseDialog" :resourceId="$customDropTree.resourceId"/>
  </div>
</template>
<script>
import chooseDialog from "./chooseDialog.vue";
export default {
  name: "item",
  components: {
    chooseDialog
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  inject: {
    $customDropTree: {
      default: null,
    },
  },
  data() {
    return {
      hover: false,
      pos: "",
      owner: this
    };
  },
  computed: {
    notReadOnly() {
      return !this.$customDropTree.isReadOnly;
    },
    show() {
      return (
        this.notReadOnly &&
        this.data.operator != "is_null" &&
        this.data.operator != "is_not_null"
      );
    },
  },
  created() {
    this.$customDropTree.buildTreeRelation();
  },
  mounted() {
    if (this.notReadOnly) {
      this.initDrag();
      this.initDrop();
    }
  },
  methods: {
    initDrag() {
      let _this = this;
      // 可以拖拽
      $(this.$el).draggable({
        helper: "clone",
        cursor: "move",
        scroll: true,
        refreshPositions: true,
        appendTo: _this.$customDropTree.getContainer,
        zIndex: 999,
        revert: "invalid",
        distance: 5,
        delay: 100,
        cursorAt: {
          left: -5,
          top: -5,
        },
        drag(event, ui) {
          _this.$customDropTree.dragAutoScroll({
            top: event.clientY,
            left: event.clientX,
          });
        },
        stop() {
          _this.$customDropTree.dragStart = false;
        },
        start() {
          _this.$customDropTree.dragStart = true;
        },
      });
    },
    initDrop() {
      let _this = this;
      // 可以放置
      $(this.$el).droppable({
        accept: _this.$customDropTree.acceptDrag,
        greedy: true,
        tolerance: "pointer",
        hoverClass: "drop-hover",
        drop($evt, ui) {
          if (_this.pos) {
            let fromData;
            if (_this.$customDropTree.dragStart) {
              //组件内部节点互相拖动
              fromData = ui.draggable.get(0).__vue__.data;
            } else {
              //与外部节点拖动
              let data = _this.$customDropTree.dragData(ui);
              if (dsf.isEmptyObject(data)) {
                return false;
              }
              fromData = _this.$customDropTree.setDataReal(data);
            }
            _this.dropToItem(fromData, _this.data, _this.pos);
          }
          _this.$customDropTree.dragStart = false;
          _this.pos = "";
        },
      });
    },
    remove() {
      this.$customDropTree.removeNode(this.data);
    },
    mouseOverHandler($evt, pos) {
      this.pos = pos;
    },
    dropToItem(fromNode, targetNode, pos) {
      this.removeNodeFromNode(fromNode);
      this.insertNode(fromNode, targetNode, pos);
      this.$customDropTree.resetTree();
    },
    removeNodeFromNode(node) {
      let items = node?.parent?.items;
      if (items) {
        dsf.array.remove(items, node);
      }
    },
    insertNode(fromNode, targetNode, pos) {
      let obj = {
        logic: this.$customDropTree.defaultLogic,
        items: [],
      };
      if (pos == "after") {
        obj.items.push(targetNode);
        obj.items.push(fromNode);
      } else {
        obj.items.push(fromNode);
        obj.items.push(targetNode);
      }
      let items = targetNode?.parent?.items;
      if (items) {
        let index = _.findIndex(items, (it) => it == targetNode);
        if (items.length == 1) {
          obj.logic = targetNode.parent.logic;
        }
        this.$customDropTree.setNode(obj);
        if (index >= 0) {
          items.splice(index, 1, obj);
        }
      }
    },
    onContextmenu(e) {
      if (!this.$customDropTree?.vContentMenu?.length || !this.notReadOnly) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      let fn = Vue.directive("contextMenu").contextMenuClick;
      let point = {
        x: e.clientX,
        y: e.clientY,
      };
      fn(point, this.data, this.$customDropTree.vContentMenu, this.$el, e);
    },
    openChoose() {
      this.$refs.chooseDialog.openFn(this.data);
    },
  },
};
</script>
